import { configureStore } from '@reduxjs/toolkit';
import appSlice from './slices/appSlice';
import { reducer as userContextReducer } from './slices/userContext';
import { apiSlice } from './api/apiSlice';
import { productApi } from './api/productApi';
import cartSlice from './slices/cartSlice';
import productReducer from './slices/productsSlice';
import { reducer as entitlementsReducer } from './slices/entitlementsSlice';

export const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    [productApi.reducerPath]: productApi.reducer,
    app: appSlice,
    userContext: userContextReducer,
    cart: cartSlice,
    product: productReducer,
    entitlements: entitlementsReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE']
      }
    }).concat(apiSlice.middleware, productApi.middleware),
  devTools: process.env.NODE_ENV !== 'production'
});

if (process.env.NODE_ENV === 'development') {
  window.store = store; // For debugging in devtools
}

// Export store and slices
export { default as appSlice } from './slices/appSlice';
export { default as cartSlice } from './slices/cartSlice';
export { reducer as userContextReducer } from './slices/userContext';
// Backwards-compatible reducer exports
export { default as cartReducer } from './slices/cartSlice';
export { default as productReducer } from './slices/productsSlice';
export { reducer as userReducer } from './slices/userContext';

// Export all actions from slices
export * from './slices/appSlice';
// Avoid conflicting star exports (appSlice + cartSlice both export `setError`)
export {
  addItem,
  setCartData,
  setCartLoading,
  clearCart,
  setPurchaseDetails,
  setCartItems,
  selectCartItems,
  selectCartItemCount,
  setValidCustomForm,
  setValidCustomPPU
} from './slices/cartSlice';
export { setError as setCartError } from './slices/cartSlice';
export {
  setProductDetails,
  setLoading as setProductLoading,
  setError as setProductError
} from './slices/productsSlice';
export * from './slices/userContext';
export { reducer as entitlementsReducer, selectRoles, selectEntitlements, selectUserRoles, selectAllowedResources } from './slices/entitlementsSlice';

// Export API slices and endpoints
export { apiSlice } from './api/apiSlice';
export { axiosBaseQuery } from './api/baseQuery';
export * from './api/homepageApi';
export * from './api/employeeWellnessPageApi';
export * from './api/apicPageApi';
export * from './api/myAppsApi';
export * from './api/productApi';
export * from './api/cartApi';
export { default as axios } from './utils/interceptor';
